module.exports = __webpack_public_path__ + "img/08-3iEvent.51ca685f.png";